import { useQuery } from '@apollo/client'
import { useTranslation } from 'next-i18next'
import { GET_RELATED_PRODUCTS } from '../../services/graphql/queries/getRelatedProducts'
import Plugin from '../Plugin'

export default function PluginRelated ({ plugin }) {
  const { t } = useTranslation('plugins')
  const { data } = useQuery(GET_RELATED_PRODUCTS, {
    variables: {
      id: plugin.id
    }
  })

  return (
    <div>
      {
        (data?.relatedProducts.length > 0) && (
          <div className="row">
            <div className="col-12">
              <h2 className="text-dark fw-bold fs-2 mb-4 mb-lg-5">{t('detail.related_plugins')}</h2>
            </div>
            <div className="col-12">
              {
                data.relatedProducts.map(plugin => (
                  <Plugin
                    key={plugin.id}
                    plugin={plugin}
                  />
                ))
              }
            </div>
          </div>
        )
      }
    </div>
  )
}
